// Contract 2.11.0: where a one-page model of the static kit fits in a carousel
// (`StudioArtTemplateSummary.page_roles`), as "Adicionar página" groups them.
export const PAGE_ROLES = ['cover', 'content', 'closing'];

// The groups to show, in order: the page's place first, then the nearest places (after a
// closing comes the body, then the cover). A model without roles (one the catalog does not
// place) is a content page.
const NEAREST = { cover: ['cover', 'content', 'closing'], content: ['content', 'cover', 'closing'], closing: ['closing', 'content', 'cover'] };
export function modelSections(models, place = 'content') {
  const order = NEAREST[place] || NEAREST.content;
  return order.map(role => ({ role, models: models.filter(model => (model.page_roles?.length ? model.page_roles : ['content']).includes(role)) }))
    .filter(section => section.models.length);
}

// Where a page added at `index` of `doc` goes: before the first page it is a cover, after the
// last a closing, anywhere else a content page.
export const placeOf = (doc, index) => (index <= 0 ? 'cover' : index >= (doc?.pages?.length || 0) ? 'closing' : 'content');
